import { render } from "./hykd.vue?vue&type=template&id=1f68bc92&scoped=true&ts=true"
import script from "./hykd.vue?vue&type=script&lang=ts"
export * from "./hykd.vue?vue&type=script&lang=ts"

import "./hykd.vue?vue&type=style&index=0&id=1f68bc92&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f68bc92"]])

export default __exports__